<template>
    <v-container class="pl-0">
        <entity-nav :navItems="navItems" useEvents></entity-nav>
        <keep-alive exclude="LammieRequestReader">
            <router-view></router-view>
        </keep-alive>
    </v-container>
</template>
<script>
import EntityNav from '../../components/EntityNav.vue'
import { mapState } from 'vuex'
import permissionsSet from '../../components/permissions'
const entity = 'lammie'
export default {
    name: 'LammieHome',
    components: {
        'entity-nav': EntityNav,
    },
    computed: {
        ...mapState(['user']),
        navItems() {
            let items = [
                { title: 'List', icon: 'mdi-view-list', to: 'lammie' },
                { title: 'Archive', icon: 'mdi-delete-outline', to: 'lammieArchive' },
            ]
            if (this.canCreate) items = [{ title: 'New', icon: 'mdi-plus', to: 'newLammie' }, ...items]

            return items
        },
        canCreate() {
            console.log(this.user)
            if (this.user && this.user[entity]) {
                return this.user[entity].owned.includes(permissionsSet.Create)
            } else {
                return false
            }
        },
    },
}
</script>
<style>
.entityView {
    width: 100%;
}
</style>
